import { BF2IsPathExpansion } from "./BF2BuildingGraphicsUtils";
var Sprite = PIXI.Sprite;
export var GetLockedGroundGraphicIso = function (data, baseSetup) {
    var y = data.y;
    var isPathTile = BF2IsPathExpansion(data, baseSetup);
    var isRotated = false;
    var variant = 1;
    if (isPathTile) {
        // Special case: path
        variant = (Math.abs(y / baseSetup.expansionsSizeY) % 2) + 1;
        isRotated = false;
    }
    else {
        variant = Math.floor((Math.random() * 30 + 30) / 10);
        isRotated = Math.floor(Math.random() * 20) % 2 === 1;
    }
    var sprite = Sprite.fromFrame("blocked_expansion_" + variant + (isPathTile ? "_path" : ""));
    // All building assets are positioned with them having anchor in bottom-center
    sprite.anchor.set(0.5, 1);
    // Rotate
    sprite.scale.x *= isRotated ? -1 : 1;
    // Tints are fine: https://github.com/pixijs/pixi.js/wiki/v4-Performance-Tips#tinting
    sprite.tint = 0xa5a5a5;
    return sprite;
};



//////////////////
// WEBPACK FOOTER
// ./src/graphics/GetLockedGroundGraphicIso.ts
// module id = 869
// module chunks = 3